import React from "react";
import { Download, Upload, ArrowRightLeft, Users, Activity, TrendingUp, Package, LifeBuoy, ArrowRight, Gift } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function QuickActions({ onDeposit, onWithdraw, onTransfer, onReferral }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const quickActions = [
    {
      img: "/assests/icons/DEPOSIT.jpg",
      title: t('dashboard.actions.deposit'),
      action: "/deposit",
      color: "from-emerald-500/25 to-emerald-400/5",
    },
    {
      img: "/assests/icons/WITHDRAW.jpg",
      title: t('dashboard.actions.withdraw'),
      action: "/withdraw",
      color: "from-rose-500/25 to-rose-400/5",
    },
    {
      img: "/assests/icons/TRANSFER.jpg",
      title: t('dashboard.actions.transfer'),
      action: "/transfer",
      color: "from-cyan-500/25 to-cyan-400/5",
    },
    {
      img: "/assests/icons/PACKS.jpg",
      title: "Packs",
      action: "/investment",
      color: "from-amber-500/25 to-amber-400/5",
    },
    {
      img: "/assests/icons/SPOT.jpg",
      title: "Spot",
      action: "/spot",
      color: "from-indigo-500/25 to-indigo-400/5",
    },
    {
      img: "/assests/icons/FUTURES.jpg",
      title: "Futures",
      action: "/futures",
      color: "from-violet-500/25 to-violet-400/5",
    },
    {
      img: "/assests/icons/TEAM.jpg",
      title: "Team",
      action: "/network",
      color: "from-blue-500/25 to-blue-400/5",
    },
    {
      img: "/assests/icons/SUPPORT.jpg",
      title: "Support",
      action: "/support",
      color: "from-fuchsia-500/25 to-fuchsia-400/5",
    }
  ];

  const handleAction = (action) => {
    switch (action) {
      case "/deposit":
        if (onDeposit) onDeposit(); else navigate('/deposit');
        break;
      case "/withdraw":
        if (onWithdraw) onWithdraw(); else navigate('/withdraw');
        break;
      case "/transfer":
        if (onTransfer) onTransfer(); else navigate('/transfer');
        break;
      default:
        navigate(action);
        break;
    }
  };

  return (
    <div className="h-full flex flex-col overflow-hidden border border-white/10 shadow-[0_12px_40px_rgba(2,6,23,0.55)] rounded-2xl bg-gradient-to-br from-slate-900/70 via-slate-900/35 to-indigo-900/20 backdrop-blur-xl">
      <div className="p-5 border-b border-slate-800/80 flex items-center justify-between bg-gradient-to-r from-white/[0.03] to-transparent">
        <h3 className="text-xs font-semibold text-white uppercase tracking-wider">{t('dashboard.actions.title')}</h3>
      </div>
      
      <div className="p-5 flex-1 flex flex-col gap-6">
        <div className="grid grid-cols-4 md:grid-cols-2 gap-3">
          {quickActions.map((action, index) => (
            <button
              key={index}
              className="group relative overflow-hidden bg-[#111827] hover:bg-slate-800 border border-slate-800 hover:border-slate-600 rounded-xl p-3 md:p-4 transition-all duration-300 flex flex-col items-center text-center hover:-translate-y-0.5"
              onClick={() => handleAction(action.action)}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${action.color} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} />
              <div className={`relative z-10 mb-1 transition-all duration-300 w-10 h-10 flex items-center justify-center group-hover:scale-110`}>
                <img src={action.img} alt={action.title} className="w-full h-full object-cover" />
              </div>
              <h4 className="relative z-10 font-semibold text-slate-300 group-hover:text-white text-[10px] md:text-xs uppercase tracking-wider">{action.title}</h4>
            </button>
          ))}
        </div>
        
        <div className="mt-auto p-5 bg-gradient-to-br from-indigo-900/40 via-slate-900 to-slate-900 rounded-xl border border-indigo-500/20 relative overflow-hidden group shadow-[0_8px_26px_rgba(79,70,229,0.16)]">
          <div className="absolute right-0 top-1/2 -translate-y-1/2 opacity-10 pointer-events-none group-hover:scale-110 transition-transform duration-500">
            <Gift size={80} />
          </div>
          <h4 className="font-semibold mb-1 text-white text-xs uppercase tracking-wider">{t('dashboard.actions.promo_title')}</h4>
          <p className="text-[11px] text-slate-300/80 mb-4 line-clamp-2">
            {t('dashboard.actions.promo_desc')}
          </p>
          <button 
            onClick={() => { if(onDeposit) onDeposit(); else navigate('/deposit'); }}
            className="w-full bg-gradient-to-r from-indigo-600 to-cyan-500 hover:from-indigo-500 hover:to-cyan-400 text-white rounded-lg py-2 flex items-center justify-center gap-2 transition-all duration-300 text-xs font-bold uppercase tracking-wider shadow-[0_8px_22px_rgba(99,102,241,0.35)]"
          >
            <span>{t('dashboard.actions.promo_cta')}</span>
            <ArrowRight size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}